import React from 'react';
import DisputeTree from '../../components/Reports/Report/Disputes/DisputeTree';

const HiddenDisputeTree = () => <DisputeTree />;

export default HiddenDisputeTree;
